import { Box, Button, Stack, Typography } from '@mui/material';
import { RotateLeftOutlined, RotateRightOutlined } from '@mui/icons-material';

export interface RotateControlsProps {
  /** Current rotation value in degrees */
  rotation: number;
  /** Callback when rotation changes */
  onRotationChange: (newRotation: number) => void;
  /** Whether the controls should be disabled */
  disabled?: boolean;
}

export const RotateControls = ({
  rotation,
  onRotationChange,
  disabled = false,
}: RotateControlsProps) => {
  const handleRotateLeft = () => {
    onRotationChange((rotation - 90) % 360);
  };

  const handleRotateRight = () => {
    onRotationChange((rotation + 90) % 360);
  };
  return (
    <Box>
      <Typography
        color="white"
        sx={{ display: { xs: 'none', md: 'block' }, mt: 1 }}
      >
        Rotate
      </Typography>

      <Stack
        direction="row"
        sx={{
          mb: { xs: 0, md: 0 },
          gap: { xs: 4, md: 2 },
        }}
      >
        <Button
          onClick={handleRotateLeft}
          disabled={disabled}
          aria-label="Rotate left"
          sx={{
            color: 'white',
            '&.Mui-disabled': {
              color: 'grey.500',
            },
            display: { xs: 'flex' },
            flexDirection: 'column',
            alignItems: 'center',
            gap: 1,
            border: { xs: 1, md: 0 },
            borderColor: 'primary.main',
          }}
        >
          <RotateLeftOutlined />
          <Typography
            color="white"
            variant="caption"
            sx={{ display: { xs: 'block', md: 'none' } }}
          >
            Rotate Left
          </Typography>
        </Button>
        <Button
          onClick={handleRotateRight}
          disabled={disabled}
          aria-label="Rotate right"
          sx={{
            color: 'white',
            '&.Mui-disabled': {
              color: 'grey.500',
            },
            display: { xs: 'flex', md: 'block' },
            flexDirection: 'column',
            alignItems: 'center',
            gap: 1,
            border: { xs: 1, md: 0 },
            borderColor: 'primary.main',
          }}
        >
          <RotateRightOutlined />
          <Typography
            color="white"
            variant="caption"
            sx={{ display: { xs: 'block', md: 'none' } }}
          >
            Rotate Right
          </Typography>
        </Button>
      </Stack>
    </Box>
  );
};

export default RotateControls;
